export default function scrollToMe(element: string, offset: number = 0): void {
  const scrollToElement = document.getElementById(element);
  if (scrollToElement) {
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = scrollToElement.getBoundingClientRect().top;
    const offsetPosition = elementRect - bodyRect - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}
